import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 下絵入力方法説明ダイアログ
 */
class ShitaeFitDialog extends Dialog {
    /**
     * コンストラクタ
     */
    targetItem: marietta.webcad.item.Shitae;

    targetLayer: marietta.webcad.layer.ShitaeLayer;

    _lineSize: number;

    get lineSize() { return this._lineSize; }

    set lineSize(value: number) {
      this._lineSize = value;
      document.querySelector('#dialogShitaeFitSize').innerHTML = String(this._lineSize);
    }

    lineSizeOrigin: number;

    _rotate: number;

    get rotate() { return this._rotate; }

    set rotate(value: number) {
      this._rotate = value;
    }

    constructor(draggable: boolean) {
      super(draggable);
      const self = this;

      // 対象の下絵を登録
      // eslint-disable-next-line prefer-destructuring
      const currentFloor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
      this.targetLayer = (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor, true) as marietta.webcad.layer.FloorShitaeLayer).layer_shitae;
      // eslint-disable-next-line prefer-destructuring
      this.targetItem = this.targetLayer.childList[0] as marietta.webcad.item.Shitae;

      const id = 'dialogShitaeFit';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Edit Picture Size And Position'; break;
        default: title = '下絵の位置と大きさの設定'; break;
      }

      const descImg1 = new Image();
      const descImg2 = new Image();
      descImg1.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_shitae01.jpg`;
      descImg2.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_shitae02.jpg`;
      descImg1.addEventListener('load', () => {
        document.querySelector('#descImg1').append(descImg1);
        self.centerDialog();
      });
      descImg2.addEventListener('load', () => {
        document.querySelector('#descImg2').append(descImg2);
        self.centerDialog();
      });
      //            descImg2.addEventListener('load', self.centerDialog);

      let contents = '';

      // 説明画面
      contents += '<div class="descriptionShitaeFit firstView">\n';
      contents += '<ol>\n';
      contents += '<li>\n';
      contents += '<div class="subTitle"><span class="jp">① 寸法の分かる２点を入力する。</span><span class="en">1) Click 2 reference points on the picture.</span></div>\n';
      contents += '<div class="cf">\n';
      contents += '<div class="fl">\n';
      contents += '<div class="descImg" id="descImg1">\n';
      //            contents += '<img src="' + descImg1.src +'" alt="下絵調整：入力方法説明図">\n';
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '<div class="fl">\n';
      contents += '<p class="descText dotMark"><span class="jp">下絵の寸法線の端<br>と端を結ぶように<br>線を描画します。</span><span class="en">Click on the <br>corners of the <br>measurements.</span></p>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '</li>\n';

      contents += '<li>\n';
      contents += '<div class="subTitle"><span class="jp">② 実際の寸法を入力する。</span><span class="en">2) Input the measurement of the 2 points.</span></div>\n';
      contents += '<div class="descImg" id="descImg2">\n';
      //            contents += '<img src="' + descImg2.src +'" alt="下絵調整：入力方法説明図">\n';
      contents += '</div>\n';
      contents += '<p class="descText"><span class="jp">下絵に記載された寸法（左図：8190）<br>を右図の実際の寸法に入力します。</span><span class="en">Input the measurement, 8190 seen on the picture to the inputbox.</span></p>\n';
      contents += '<p class="descTextNote"><span class="jp">※数値入力後に下絵の拡大などを行うと寸法が崩れる場合がございます。<br>下絵編集より「リセットボタン」で正常位置へ戻してください。</span><span class="en">*Use the "Reset" button if you wish to reverse the usage of the zoom buttons.</span></p>\n';
      contents += '</li>\n';
      contents += '</ol>\n';
      contents += '</div>\n';

      // 入力した値の取得に成功
      contents += '<div class="dialogShitaeFitInputBox completeView">\n';
      contents += '<p><label><span class="jp">入力された寸法: </span><span class="en">Measurement Detected : </span><span id="dialogShitaeFitSize">--</span> mm</p>\n';
      contents += '<p><label><span class="jp">実際の寸法: </span><span class="en">Measurement on Picture : </span><input id="dialogShitaeFitInput" value="" type="number" min="1" max="99999" placeholder="1000"> mm</label></p>\n';
      contents += '<p class="errorMsg"></p>\n';
      contents += '</div>\n';

      // 入力した値が取得できなかった
      contents += '<div class="errorShitaeFit errorView">\n';
      contents += '<p><span class="jp">2点の距離が正しく取得できませんでした。<br>もう一度入力してください。</span><span class="en">Not able to detect a suitable distance between the 2 points.<br>Please try again.</span></p>\n';
      contents += '</div>\n';

      let footer = '';
      footer += '<button id="btnDialogShitaeFitInput" class="firstView"><span class="jp">入力する</span><span class="en">Input</span></button>\n';
      footer += '<button id="btnDialogShitaeFitConfirm" class="completeView"><span class="jp">OK</span><span class="en">OK</span></button>\n';
      footer += '<button id="btnDialogShitaeFitReInput" class="completeView errorView"><span class="jp">やり直す</span><span class="en">Redo</span></button>\n';
      footer += '<button id="btnDialogShitaeFitSkip" class="firstView completeView"><span class="jp">スキップ</span><span class="en">Skip</span></button>\n';

      this.createDialog(id, title, contents, footer);

      document.querySelector('#btnDialogShitaeFitConfirm').addEventListener('click', self.onClickConfimrBtnHandler);
      document.querySelector('#btnDialogShitaeFitInput').addEventListener('click', self.startInputDistance);
      document.querySelector('#btnDialogShitaeFitReInput').addEventListener('click', self.startInputDistance);
      document.querySelector('#btnDialogShitaeFitSkip').addEventListener('click', self.close);

      (this.viewObj).querySelectorAll('.completeView').forEach((elem) => {
        elem.setAttribute('style', 'display:none');
      });
      (this.viewObj).querySelectorAll('.errorView').forEach((elem) => {
        elem.setAttribute('style', 'display:none');
      });
      (this.viewObj).querySelectorAll('.firstView').forEach((elem) => {
        elem.setAttribute('style', 'display:""');
      });
    }

    /**
     * OKボタンが押された
     */
    onClickConfimrBtnHandler = () => {
      const lineSizeOrigin: number = Number((<HTMLInputElement>document.querySelector('#dialogShitaeFitInput')).value);
      if (Number.isNaN(lineSizeOrigin)) {
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'en': (this.viewObj).querySelectorAll('.errorMsg').forEach((elem) => {
            const param = elem;
            param.innerHTML = 'Please input numeric characters.';
          }); break;
          default: (this.viewObj).querySelectorAll('.errorMsg').forEach((elem) => {
            const param = elem;
            param.innerHTML = '半角で数値を入力してください。';
          }); break;
        }

        return;
      }
      if (lineSizeOrigin <= 0) {
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'en': (this.viewObj).querySelectorAll('.errorMsg').forEach((elem) => {
            const param = elem;
            param.innerHTML = 'Please input a value within 1 and 99999.';
          }); break;
          default: (this.viewObj).querySelectorAll('.errorMsg').forEach((elem) => {
            const param = elem;
            param.innerHTML = '1 ～ 99999 で寸法を入力してください';
          }); break;
        }

        return;
      }
      (this.viewObj).querySelectorAll('.errorMsg').forEach((elem) => {
        const param = elem;
        param.innerHTML = 'Please input a value within 1 and 99999.';
      });
      // 拡大率をFITさせる
      const scale = lineSizeOrigin / this.lineSize;
      this.targetLayer.defaultScale = scale;
      this.targetItem.spt.scaleX = scale;
      this.targetItem.spt.scaleY = scale;
      this.targetItem.spt.update();

      // 角度をあわせる
      let rotate = Math.abs(this.rotate);
      const pm = -(this.rotate / Math.abs(this.rotate));// +/-
      for (let i = 0; i < 5; i += 1) {
        if (Math.abs(rotate) < 45) break;
        rotate = Math.abs(rotate) - 90;
      }
      if (Math.abs(rotate) > 1) {
        // 角度のずれが1度以上あるなら角度も反映させる
        rotate *= pm;
        if (rotate !== 0) this.targetItem.rotate(rotate);
      }

      // 調整後の下絵がステージをはみ出るなら全体のスケールを調整
      const marginSize = document.querySelector('#itemMenu_shitae').clientWidth;
      //   const stageBound = $('#webcad2dViewInner').get(0).getBoundingClientRect();
      //   const layerGroupBound = $('#layerGroup').get(0).getBoundingClientRect();
      //   const scrollBarWidth = $('#webcad2dViewInner').innerWidth() - $('#webcad2dViewInner').get(0).clientWidth;
      //   const minPoint = new marietta.core.Point((stageBound.left - layerGroupBound.left) / marietta.webcad.WebCADGlobal.scaleSize, (stageBound.top - layerGroupBound.top) / marietta.webcad.WebCADGlobal.scaleSize);
      //   const maxPoint = new marietta.core.Point(minPoint.x + ((stageBound.width - scrollBarWidth) / marietta.webcad.WebCADGlobal.scaleSize), minPoint.y + ((stageBound.height - scrollBarWidth) / marietta.webcad.WebCADGlobal.scaleSize));
      const imgRect = this.targetItem.viewObj.getBoundingClientRect();

      // 拡大率を修正
      const stageH = document.querySelector('#webcad2dViewInner').clientHeight;
      marietta.webcad.WebCADGlobal.scrollerManager.setScale(marietta.webcad.WebCADGlobal.scaleSize * (stageH / imgRect.height));

      // ステージを下絵の座標へ移動
      const newImgRect = this.targetItem.viewObj.getBoundingClientRect();
      const scrollW = this.targetItem.spt.x * marietta.webcad.WebCADGlobal.scaleSize - newImgRect.width / 2 - marginSize;
      const scrollH = this.targetItem.spt.y * marietta.webcad.WebCADGlobal.scaleSize - newImgRect.height / 2;
      console.log(scrollH);
      document.querySelector('#webcad2dViewInner').scrollLeft = scrollW;
      document.querySelector('#webcad2dViewInner').scrollTop = scrollH;
      // コントローラダイアログに戻る
      marietta.webcad.WebCADGlobal.removeDialog();
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ShitaeControllerDialog2, true, true, false);
    }

    /**
     * 頂点入力を開始する
     */
    startInputDistance = () => {
      this.hide();
      marietta.webcad.WebCADGlobal.itemManager.itemController = new marietta.webcad.control.ItemControllerShitaePointInput();
    }

    /**
     * ダイアログを閉じる(override)
     */
    closeEvent() {
      super.closeEvent();

      // グリッドの色を元に戻す
      document.querySelector('#Layer0_0_FILL_gridLineh').querySelector('path').style.stroke = '#ccc';
      document.querySelector('#Layer0_0_FILL_gridLinev').querySelector('path').style.stroke = '#ccc';

      // 下絵コントローラを表示
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ShitaeControllerDialog2, true, true, false);
    }

    /**
     * 非表示
     */
    hide() {
      this.viewObj.style.display = 'none';
      // モーダルカラーを薄くする
      document.getElementById('modalBg').style.cssText = 'background-color:#000;display:block;opacity: 0.2;pointer-events:none';
    }

    /**
     * 表示
     */
    show() {
      (this.viewObj).style.display = 'block';
      if (this.lineSize) {
        (this.viewObj).querySelectorAll('.firstView').forEach((elem) => {
          elem.setAttribute('style', 'display:none');
        });
        (this.viewObj).querySelectorAll('.errorView').forEach((elem) => {
          elem.setAttribute('style', 'display:none');
        });
        (this.viewObj).querySelectorAll('.completeView').forEach((elem) => {
          elem.setAttribute('style', 'display:""');
        });
      } else {
        (this.viewObj).querySelectorAll('.firstView').forEach((elem) => {
          elem.setAttribute('style', 'display:none');
        });
        (this.viewObj).querySelectorAll('.errorView').forEach((elem) => {
          elem.setAttribute('style', 'display:""');
        });
        (this.viewObj).querySelectorAll('.completeView').forEach((elem) => {
          elem.setAttribute('style', 'display:none');
        });
      }

      // ダイアログのリサイズ
      this.centerDialog();

      // モーダルカラーを濃くする
      document.getElementById('modalBg').style.cssText = 'background-color:#000;display:block;opacity: 0.2;pointer-events:auto';
    }
}
export default ShitaeFitDialog;
